import axios from 'axios'

import { formatDate } from '../../@paco/helpers/date'
import { DateFormat } from '../../@paco/types/dateFormatTypes'

import {
    ApiResponse,
    Filter,
    ShiftResource,
    ShiftViewModel,
} from '../../models'
import { transformShiftResource } from '../../services/ShiftService/transformShiftResource'

interface GetShiftsParams {
    filter: Filter;
    startDate: Date;
    endDate: Date;
    departments: string[];
    includes?: string[];
}

let geShiftsApiCallAbortController = new AbortController()

export const getShifts = async (params: GetShiftsParams): Promise<ShiftViewModel[]> => {
    const {
        includes = [],
        filter,
        startDate,
        endDate,
        departments,
    } = params
    const { employeeSearch: search } = filter || {}

    geShiftsApiCallAbortController.abort()
    geShiftsApiCallAbortController = new AbortController()

    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/shifts/old`,
        {
            params: {
                include: includes.join(','),
                ...(search && { search }),
                startDate: formatDate(startDate, DateFormat.apiDateTime),
                endDate: formatDate(endDate, DateFormat.apiDateTime),
                departments: (departments && departments.length > 0) ? JSON.stringify(departments) : undefined,
            },
            signal: geShiftsApiCallAbortController.signal,
        },
    ) as unknown as ApiResponse<ShiftResource[]>

    return response.data.map((shift: ShiftResource) => transformShiftResource(
        shift,
        shift.plannedUsers,
        shift.shiftPlannings,
        shift.department,
        shift.temporaryWorkers,
        shift.previouslyPlannedUsers,
    ))
}
